export { default } from './cart-preview-entry.default';
